import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const QuestionsTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Name",
			dataIndex: "name",
			width: 250,
			ellipsis: true,
		},
		{
			title: "Survey Category",
			dataIndex: "survey_category",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{record.name}</span>;
			},
		},
		{
			title: "Updated At",
			dataIndex: "updated_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default QuestionsTable;
